import SkapaElement from '@ingka/skapa-webc-element';
// @ts-ignore
const styles = ':host{--skapa-icon-rotate:0deg;display:inline-block;height:1.5rem;transform:rotate(var(--skapa-icon-rotate));transition-duration:.25s;transition-property:fill;transition-timing-function:cubic-bezier(.4,0,.4,1);vertical-align:middle;width:1.5rem}:host ::slotted(svg),:host svg{fill:currentColor;max-height:100%;max-width:100%}:host svg{display:none}:host([icon]) svg{display:unset}:host([icon]) slot{display:none}:host([rotate]){transition-property:transform,fill}:host([skapa-rtl][flip-rtl]) ::slotted(svg),:host([skapa-rtl][flip-rtl]) svg{transform:scaleX(-1)}@media (prefers-reduced-motion){:host([rotate]){transition-property:none}}:host([rotate="45"]){--skapa-icon-rotate:45deg}:host([rotate="-45"]){--skapa-icon-rotate:-45deg}:host([rotate="-135"]){--skapa-icon-rotate:-135deg}:host([rotate="135"]){--skapa-icon-rotate:135deg}:host([rotate="180"]){--skapa-icon-rotate:180deg}:host([rotate="-180"]){--skapa-icon-rotate:-180deg}:host([rotate=loop]){animation:icon-rotate 1.5s linear infinite}@keyframes icon-rotate{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}';
import { getPaths } from '@ingka/icon-store';
import { html, RTLObserver } from '@ingka/webc-tools';
import { svgNodeRenderer } from './tools/svg-renderer.js';
const stylesTemplate = document.createElement('template');
stylesTemplate.innerHTML = html `<style>${styles}</style>`;
const svgTemplate = document.createElement('template');
svgTemplate.innerHTML = html `<slot></slot><svg viewBox="0 0 24 24"></svg>`;
export class Icon extends SkapaElement {
    constructor() {
        super();
        this.__paths = [];
        this.updatePaths = () => {
            this.paths = getPaths(this.icon);
        };
        this.render = () => {
            const paths = svgNodeRenderer(this.__paths); // don't rerender if it's rendered and the same
            this.__svg.innerHTML = '';
            if (paths)
                this.__svg.append(...paths);
        };
        this.gatherProperties(['paths', 'flipRTL', 'icon', 'viewBox'], this); // Manages inherited pre-definition properties.
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.append(stylesTemplate.content.cloneNode(true), svgTemplate.content.cloneNode(true));
        this.__svg = shadow.querySelector('svg');
    }
    get paths() {
        return this.__paths;
    }
    set paths(val) {
        if (val !== this.__paths && Array.isArray(val)) {
            this.__paths = val || [];
            if (this.isConnected)
                this.micro(this.render, 'skapa-icon-render');
        }
    }
    get icon() {
        return this.getAttribute('icon');
    }
    set icon(name) {
        if (name)
            this.setAttribute('icon', name);
        else
            this.removeAttribute('icon');
    }
    get flipRTL() {
        return this.hasAttribute('flip-rtl');
    }
    set flipRTL(value) {
        this.toggleAttribute('flip-rtl', !!value);
    }
    /**
     * Warning! This is an internal feature, it's not meant to be used by the user.
     * The implementation may change without notice!
     * @param val - The value to set as the viewBox attribute.
     */
    set viewBox(val) {
        this.__svg.setAttribute('viewBox', val);
    }
    get viewBox() {
        return this.__svg.getAttribute('viewBox') || '';
    }
    attributeChangedCallback(attrName) {
        if (!this.isConnected)
            return; // Any work that's done here will be done again when the component is connected.
        if (attrName === 'icon')
            this.updatePaths();
        if (attrName === 'flip-rtl') {
            if (this.flipRTL)
                RTLObserver.addTarget(this);
            else
                RTLObserver.removeTarget(this);
        }
    }
    // This feature ensures that the clonded node will display the icon as well
    cloneNode(deep) {
        const clone = super.cloneNode(deep);
        clone.paths = this.paths;
        return clone;
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.hasAttribute('aria-hidden') && !this.ariaHidden) {
            this.setAttribute('aria-hidden', 'true');
        }
        if (this.icon)
            this.updatePaths();
        if (this.flipRTL)
            RTLObserver.addTarget(this);
        this.render();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        RTLObserver.removeTarget(this);
    }
}
Icon.observedAttributes = ['icon', 'flip-rtl'];
export default Icon;
